import { useQuery } from '@tanstack/react-query';

import { EntityMembershipPolicies } from '@graylog/enterprise-api';

import type { EntityMembershipPolicy } from 'collections/types';
import { defaultOnError } from 'util/conditional/onError';

export const MEMBERSHIP_POLICIES_QUERY_KEY = 'membership-policies';

export const keyFn = (entityId: string, entityType: string) => [MEMBERSHIP_POLICIES_QUERY_KEY, entityType, entityId];

export const fetchMembershipPolicies = async (
  entityId: string,
  entityType: string,
): Promise<Array<EntityMembershipPolicy>> => EntityMembershipPolicies.getByInitiatorId(entityType, entityId);

const useEntityMembershiPolicies = (
  entityId: string,
  entityType: string,
  { enabled } = { enabled: true },
): {
  data: Array<EntityMembershipPolicy>;
  isLoading: boolean;
  refetch: () => void;
} => {
  const { data, isFetching, refetch } = useQuery({
    queryKey: keyFn(entityId, entityType),
    queryFn: () =>
      defaultOnError(
        fetchMembershipPolicies(entityId, entityType),
        'Loading Membership policies for entity failed with status',
        'Could not load Membership policies for entity',
      ),
    enabled,
  });

  return {
    data: data ?? null,
    isLoading: isFetching,
    refetch,
  };
};

export default useEntityMembershiPolicies;
